import React from 'react';

const Send = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0693 8.50965L9.50929 4.22965C3.75929 1.34965 1.39929 3.70965 4.27929 9.45965L5.14929 11.1996C5.39929 11.7096 5.39929 12.2996 5.14929 12.8096L4.27929 14.5396C1.39929 20.2896 3.74929 22.6496 9.50929 19.7696L18.0693 15.4896C21.9093 13.5696 21.9093 10.4296 18.0693 8.50965ZM14.8393 12.7496H9.43929C9.02929 12.7496 8.68929 12.4096 8.68929 11.9996C8.68929 11.5896 9.02929 11.2496 9.43929 11.2496H14.8393C15.2493 11.2496 15.5893 11.5896 15.5893 11.9996C15.5893 12.4096 15.2493 12.7496 14.8393 12.7496Z"
        fill="#3772FF"
      />
    </svg>
  );
};

export default Send;
